export default __webpack_public_path__ + "static/media/Money.fa393416.svg";